@if (showContactsSection()) {
  <div class="bp-modal-padding-container">
    <h4 class="contacts-list-headline">{{ "my_contacts" | translate }}</h4>
  </div>
  <div class="contacts-list bp-modal-padding-container">
    @for (contact of getFilteredContacts(); track contact) {
      <contact-list-item
        class="contacts-list-item"
        (click)="selectContact(contact)"
        [contact]="contact">
      </contact-list-item>
    }
  </div>
}
@if (showFilteredContacts()) {
  <ul class="contacts-list bp-modal-padding-container">
    @if (showNewAddressField()) {
      <li class="contacts-list-item" (click)="selectNewAddress()">
        <div class="contacts-list-item-image-container-negative new">
          <span class="bpi__icon-send"></span>
        </div>
        <div class="contacts-list-item-content">
          <div class="contacts-list-item-name">
            <span>{{ "send_to_new_address" | translate }}</span>
          </div>
          <bp-info class="mod-overflow">{{ currentSearchString }}</bp-info>
        </div>
      </li>
    }
    @for (field of filteredContacts(); track field) {
      <li class="contacts-list-item" (click)="selectFilteredContact(field)">
        @if (field?.getType() === 'email') {
          <div
            class="contacts-list-item-image-container-negative email">
            <span class="bpi__icon-{{ field?.getSymbol() | lowercase }}"></span>
          </div>
        } @else {
          <div class="contacts-list-item-image-container-negative asset">
            <span class="{{ asset?.getIconCssName(true) }}"></span>
          </div>
        }
        <div class="contacts-list-item-content">
          <a href="javascript:" class="color-text">
            <div class="contacts-list-item-name" [innerHtml]="getFieldStringByUseCase(field)"></div>
          </a>
          <div class="flex">
            <bp-info class="mod-overflow mod-sendflow" [innerHtml]="getFieldStringByUseCase(field, 'value')">
            </bp-info>
            @if (field.getDestinationTag()) {
              <span class="text-lightest">
                /
                {{ field.getDestinationTag() }}
              </span>
            }
          </div>
          @if (showContactInfo(field)) {
            <bp-info
              class="contacts-list-item-info"
            [innerHtml]="getFieldStringByUseCase(field, 'info')"></bp-info>
          }
        </div>
      </li>
    }
  </ul>
}
